<template>
  <div>
    <div v-if="info.userType === 'INNERCOMPANY'">
      <div class="home-box">
        <el-card class="box-left"  shadow="never">
          <h2 slot="header">资方信息</h2>
          <h3 style="line-height: 60px; margin-top: -20px;">企业信息</h3>
          <div class="en_info"><span> 企业名称：</span> {{perfectInfoObj.corporateName}}</div>
          <div class="en_info"><span> 组织机构代码：</span> {{info.oidUserno}}</div>
          <div class="en_info"><span>联系人手机号：</span> {{info.mobile}}</div>
          <h3 style="line-height: 60px;">充值所需信息</h3>
          <div class="warning_tip">
            <i class="el-icon-warning" style="padding:2px 4px 0 0;font-size: 14px;"></i>
            <div>
              <div>1.以下信息只限同名公户充值，个人户及异名公户禁止充值。</div>
              <div>2.因充值信息填错所导致的一切后果由机构自行承担。</div>
            </div>
          </div>
          <div class="en_info"><span> 开户名：</span>  {{ info.deptName }} </div>
          <div class="en_info"><span> 账号：</span>  {{info.bankAccount}} </div>
          <div v-if="info.payChannelId == 1">
            <div class="en_info"><span> 开户行：</span> 商盟商务-备付金账户 </div>
          </div>
          <div v-if="info.payChannelId == 0">
            <div class="en_info"><span> 开户支行：</span> 连连银通-备付金账户 </div>
            <div class="en_info"><span> 开户银行（行别）：</span> 支付机构备付金集中存管账户（或者“其它991”）</div>
            <div class="en_info"><span> 开户行号：</span>  991331000295</div>
            <div class="en_info"><span> 省：</span> 浙江省  市：杭州市</div>
            <h3 style="line-height: 60px;">充值时效</h3>
            <div class="en_info"><span> 1 </span> 下列五家银行充值5分钟内到账，(7x24小时，不受节假日影响):</div>
            <div class="en_info kg"><span></span>中国银行、平安银行、兴业银行、杭州银行、浙商银行</div>
            <div class="en_info"><span> 2 </span> 招商银行充值(5分钟内到账) : </div>
            <div class="en_info kg">只支持行政班工作时段 8:30--17:15</div>
            <div class="en_info"><span>3 </span>其他银行充值 (5 分钟内到账):</div>
            <div class="en_info kg">工作日:0:00--17:15，20:30--24: 00</div>
            <div class="en_info kg">节假日前一日: 0:00--17:15</div>
            <div class="en_info kg">节假日最后一日: 20:30--24:00</div>
            <div class="en_info"><span>4 </span>充值成功后，放款实时到账。</div>
          </div>
          <div class="flex">
            <h3 style="line-height: 60px;">债转信息</h3>
            <el-button v-if="info.userType === 'INNERCOMPANY' && $hasPermission('loan:auth:updateLoanData')" class="editBtn"  type="text" size="small" @click="addOrUpdateHandle(perfectInfoObj.id)">修改债转信息</el-button>
          </div>
          <div class="en_info"><span> 受让方：</span> {{ perfectInfoObj.corporateName }}</div>
          <div class="en_info"><span> 法定代表人：</span> {{ perfectInfoObj.legalRepresentative }}</div>
          <div class="en_info"><span> 住所：</span> {{ perfectInfoObj.dwellingPlace }}</div>
          <div class="en_info"><span> 受让方联系人：</span> {{ perfectInfoObj.creditorRight }}</div>
          <div class="en_info"><span> 受让方电话：</span> {{ perfectInfoObj.creditorTelephone }}</div>

        </el-card>
        
        <div class="box-right">
          <div class="warn_tip1" v-if="balance.blockUpDate && balance.status == '0' && balance.availableBalance < 0">
            <i class="el-icon-warning"></i>
            <span>尊敬的{{balance.enterpriseName}}，截至{{formatDate()}}您已欠费{{balance.arrearageHour}}小时，您的放款服务将于欠费{{infoList.length>0 ? infoList[1].value : 0}}小时后({{formatDate(balance.blockUpDate)}})自动停用，请及时充值以免影响使用。</span>
          </div>
          <div class="warn_tip" v-else-if="balance.status == '1' && balance.availableBalance < 0">
            <i class="el-icon-warning"></i>
            <span>尊敬的{{balance.enterpriseName}}，截至{{formatDate(balance.blockUpDate)}}您的账户已欠费{{infoList.length>0 ? infoList[1].value : 0}}h以上，放款服务已暂停，如您需要继续使用该服务，请及时缴费</span>
          </div>
          <div class="warn_tip1" v-if="isOverDate == true">
            <i class="el-icon-warning"></i>
            <span>尊敬的{{balance.enterpriseName}}，贵企业平台账户将于{{formatDate(balance.periodOfValidity)}}到期，届时账户将被停用，为避免业务受影响，请尽快缴付年费。</span>
          </div>
          <div class="warn_tip" v-if="isOverDate1 == true">
            <i class="el-icon-warning"></i>
            <span>尊敬的{{balance.enterpriseName}}，截止{{formatDate(balance.periodOfValidity)}}您的年费已到期，平台账户已停用，如您需要继续使用平台服务，请及时缴费。</span>
          </div>
        <el-card shadow="never">
          <h3 style="margin-bottom: -10px;">总览</h3>
          <div style="display: flex;">
            <div v-if="info.datas.length >0">
              <div class="view_box" v-for="(item,index) in info.datas" :key="index">
                <div class="v_top">
                  <div>{{item.name}}账户可用余额</div>
                  <div class="open_account">{{(item.userStatus == false && info.type == 'PRIMARY_ACCOUNT_NUMBER') ? '未开户' : '已开户'}}</div>
                </div>
                <div class="v_bottom">
                  <div class="v_price">￥{{item.amtBalaval ? item.amtBalaval.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                  <div v-if="item.userStatus == false && info.type == 'PRIMARY_ACCOUNT_NUMBER' && item.name == '连连支付'">
                    <el-button type="primary" size="mini" @click="account()">开户</el-button>
                  </div>
                  <div style="display: flex;" v-else-if="item.userStatus == true">
                    <el-button class="editBtn" v-if="$hasPermission('loan:home:withdrawdeposit') && item.name == '连连支付'" @click="withdraw()">提现</el-button>
                    <el-button class="editBtn" v-if="$hasPermission('user:auth:userChangeLianLianPayPassword') && item.name == '连连支付'"  @click="changePwd()">修改三方支付密码</el-button>
                  </div> 
                </div>  
              </div>
            </div>
            <div class="view_box" style="margin-left: 20px;display: flex;align-items: center;" >
              <div class="remaining">
                <div class="v_top v-left">
                  <div style="font-weight: bold;">中运平台账户可用额度</div>
                  <div class="v_price" :style="balance.availableBalance < 0 ? 'color:#f20f0f' : 'color:#2d3440'">￥{{balance.availableBalance ? balance.availableBalance.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                  <div class="open_account" v-if="balance.status == '0'">有效期至：{{formatDate1(balance.periodOfValidity)}}</div>
                  <div class="account_status" v-else>已停用</div>
                </div>
                <div class="v_bottom">
                  <div style="display: flex;">
                    <el-button class="editBtn" @click="goDetail()">收支明细</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card v-if="$hasPermission('system:data:userId')" shadow="never" class="overview" :style="(isOverDate == false &&  !balance.blockUpDate) ? 'min-height: 745px;height:62vh' :(isOverDate == false &&  balance.blockUpDate && balance.status == '0' || balance.status == '1') ? 'min-height: 720px;height:60vh' : 'min-height: 695px;height:58vh'">
          <h2 slot="header">{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月费用概览</h2>
          <div class="fee_box">
            <div class="f_left">
              <div class="month_amount">
                <div>{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月放款总额/元 </div>
                <div class="f-price color">{{infoData.loanTotalMoney ? infoData.loanTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
              </div>
              <div class="month_fee">
                <div class="mon_top">
                  <div class="t_left">
                    <div>{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月通道费/元</div>
                    <div class="t_price">{{ infoData.annual && infoData.annual.totalMoney ? infoData.annual.totalMoney.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' }}
                    </div>
                  </div>
                  <div class="t_right">
                    <img src="../../assets/img/channel.jpg" alt="">
                  </div>
                </div>
                <div class="mon_bottom">
                  <div class="b_left">
                    <div class="limit">
                      <div class="limit_left">
                        <div class="total_amount">￥{{infoData.annual && infoData.annual.pledgeMonet ? infoData.annual.pledgeMonet.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                        <div>抵押放款总额</div>
                      </div>
                      <div class="loan_price">{{infoData.annual && infoData.annual.feesPledgeMonet ? infoData.annual.feesPledgeMonet.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                    </div>
                    <div class="limit" style="margin-top: 14px;">
                      <div class="limit_left">
                        <div class="total_amount">￥{{infoData.annual && infoData.annual.noPledgeMonet ? infoData.annual.noPledgeMonet.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                        <div>非抵押放款总额</div>
                      </div>
                      <div class="loan_price">{{infoData.annual && infoData.annual.feesNoPledgeMonet ? infoData.annual.feesNoPledgeMonet.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                    </div>
                  </div>
                  <div class="b_right" @click="goDetail(Number(infoData.month))">
                    <img src="../../assets/img/arrow_right.svg" alt="">
                  </div>
                </div>
              </div>
              <div class="sign_fee">
                <div class="s_top">
                  <div class="s_left">
                    <div class="s_title">
                      <span>{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月电子签章服务费</span>
                      <el-popover
                        placement="top"
                        trigger="hover"
                      >
                        <span style="color: #95aac9;">{{infoData.esgin ? infoData.esgin.label : ''}}</span>
                        <img slot="reference" src="../../assets/img/question.svg" alt="">
                      </el-popover>
                      
                    </div>
                    <div class="s_price">￥ {{infoData.esgin &&  infoData.esgin.totalMoney ? infoData.esgin.totalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                  </div>
                  <div class="s_right">
                    <img src="../../assets/img/esign.png" alt="">
                  </div>
                </div>
                <div class="s_bottom">
                  放款成功： <span class="s_number">{{infoData.esgin && infoData.esgin.strokeCount ? infoData.esgin.strokeCount : '0'}}笔</span>
                </div>
              </div>
            </div>
            <div class="f_right">
              <div class="month_amount">{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月技术服务费总额/元 <span class="f-price">{{infoData.feeTotalMoney ? infoData.feeTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</span></div>
              <div class="sign_fee">
                <div class="s_top">
                  <div class="s_left">
                    <div class="s_title">
                      <span>{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月三方支付服务费</span>
                      <!-- <el-popover
                        placement="top"
                        trigger="hover"
                      >
                        <span style="color: #95aac9;">{{ infoData.payment ? infoData.payment.label : '' }}</span>
                        <img slot="reference" src="../../assets/img/question.svg" alt="">
                      </el-popover> -->
                    </div>
                    <div class="s_price">￥ {{ infoData.payment && infoData.payment.totalMoney ? infoData.payment.totalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                  </div>
                  <div class="s_right">
                    <img src="../../assets/img/dollar.jpg" alt="">
                  </div>
                </div>
                <div class="s_bottom">
                  充值： <span class="s_number">{{infoData.payment ? infoData.payment.topUpCount : '0'}}笔</span>
                  放款： <span class="s_number">{{infoData.payment ? infoData.payment.loanCount : '0'}}笔</span>
                  提现： <span class="s_number">{{infoData.payment ? infoData.payment.withdrawDepositCount : '0'}}笔</span>
                </div>
              </div>
              <div class="sign_fee notarization_fee">
                <div class="s_top">
                  <div class="s_left">
                    <div>{{infoData.month ? Number(infoData.month) : new Date().getMonth() + 1}}月公证服务费</div>
                    <div class="s_price">￥ {{ infoData.notarization &&  infoData.notarization.totalMoney ? infoData.notarization.totalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
                  </div>
                  <div class="s_right">
                    <img src="../../assets/img/notarize.png" alt="">
                  </div>
                </div>
                <div class="s_bottom" v-if="infoData.notarization">
                  <div v-for="(item,index) in infoData.notarization.list" :key="index">{{item.condition}}<span class="s_number" style="padding-left: 10px;"> {{item.count}}笔</span></div>
                 
                </div>
              </div>
            </div>
          </div>
        </el-card>
        </div> 
      </div>
    </div>
    <!-- <div class="admin_box" >
      <div class="inquire_box">
        <el-form label-width="60px" class="inquire_form">
          <el-form-item label="年份" >
            <el-select v-model="selectedYear" @change="updateMonths" placeholder="请选择">
              <el-option
                v-for="(item,index) in yearsList"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份" >
            <el-select v-model="selectedMonth" filterable clearable @change="updateDays" placeholder="请选择">
              <el-option
                v-for="(item,index) in monthsList"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" >
            <el-select v-model="selectedDay" filterable clearable  placeholder="请选择">
              <el-option
                v-for="(item,index) in daysList"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item >
            <el-button class="btn_search" type="primary" @click="query()">查询</el-button>
          </el-form-item>
         
        </el-form>
        
      </div>
      <div class="data_show">
        <el-card shadow="never" class="show_item" >
          <div class="item_content">
            <div class="s_left">
              <div class="num"><span style="font-size: 16px;">￥</span>3,342,432,423</div>
              <div class="tip">总利润</div>
            </div>
            <div class="s_right">
              <img src="../../assets/img/home_top1.png" alt="">
            </div>
          </div>
        </el-card>
        <el-card shadow="never" class="show_item" >
          <div class="item_content">
            <div class="s_left">
              <div class="num">100</div>
              <div class="tip">新增机构（个）</div>
            </div>
            <div class="s_right">
              <img src="../../assets/img/home_top2.jpg" alt="">
            </div>
          </div>
        </el-card>
        <el-card shadow="never" class="show_item">
          <div class="item_content">
            <div class="s_left">
              <div class="num"><span style="font-size: 16px;">￥</span>3,342,432,423</div>
              <div class="tip">充值</div>
            </div>
            <div class="s_right">
              <img src="../../assets/img/home_top3.jpg" alt="">
            </div>
          </div>
        </el-card>
        <el-card shadow="never" class="show_item">
          <div class="item_content">
            <div class="s_left">
              <div style="display: flex;align-items: center;">
                <img style="height: 24px;margin-right: 8px;" src="../../assets/img/home_arrow_up.svg" alt="">
                <div class="num">10%</div>
              </div>
              <div class="tip" style="color: #333;">充值环比</div>
            </div>
            <div class="s_right">
              <img src="../../assets/img/home_top4.jpg" alt="">
            </div>
          </div>
        </el-card>
      </div>
      <div class="echarts">
        <el-card shadow="never" class="card_left">
          <div class="tendency_title">
            <div class="card_title">利润趋势</div>
            <div class="date_select">
              <el-select v-model="dateValue"  @change="changeDate" placeholder="请选择">
                <el-option
                  v-for="(item,index) in dateOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>         
          <div id="tendency" style="width: 100%; height: 400px;"></div>
        </el-card>
        <el-card shadow="never" class="card_right">
          <div class="card_title">资方来源占比</div>
          <div style="width: 100%; height: 400px;">
            <el-table  height="380" stripe :data="rankList" style="width: 100%;">
              <el-table-column prop="ranking"  label="序号" header-align="center" align="center"></el-table-column>
              <el-table-column prop="funding"  label="来源" header-align="center" align="center"></el-table-column>
              <el-table-column prop="nopledge"  label="机构数" header-align="center" align="center"></el-table-column>
              <el-table-column prop="pledge"  label="放款金额" header-align="center" align="center">
                <template slot-scope="scope">
                 <div v-if="scope.row.pledge != null">{{'￥'+ Number(scope.row.pledge).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
                </template>
              </el-table-column>      
              <el-table-column prop="channel"  label="利润" header-align="center" align="center"></el-table-column>
              <el-table-column prop="channel"  label="利润占比" header-align="center" align="center"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
      <div class="data_list">
        <el-card shadow="never" class="card_left">
          <div class="analyse">机构活跃分析</div>
          <div class="analyse_data">
            <div id="funnel" style="width: 50%; height: 300px; "></div>
            <div class="anal_num">
              <div class="num1">机构总数（个）：<span>234</span></div>
              <div class="num2">近一月交易机构（个）：<span>444</span></div>
              <div class="num3">当日交易机构（个）：<span>678</span></div>
            </div>
          </div>
        </el-card>
        <el-card shadow="never" class="card_right">
          <div class="card_title">资方利润TOP10排名</div>
          <el-table height="360" :data="rankList" style="width: 100%;margin-top: 6px;">
            <el-table-column prop="ranking" sortable label="排名" header-align="center" align="center"></el-table-column>
            <el-table-column prop="funding" sortable label="资方" header-align="center" align="center"></el-table-column>
            <el-table-column prop="pledge" sortable label="放款总额" header-align="center" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.pledge != null">{{'￥'+ Number(scope.row.pledge).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </template>
            </el-table-column>      
            <el-table-column prop="nopledge" sortable label="放款件均" header-align="center" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.nopledge != null">{{'￥'+ Number(scope.row.nopledge).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="channel" sortable label="利润" header-align="center" align="center"></el-table-column>
            <el-table-column prop="channel" sortable label="利润率" header-align="center" align="center"></el-table-column>
          </el-table>
        </el-card>
      </div>
      
    </div> -->
    
    <el-card class="box-card1" v-show = "isSHowPasswordControl">
        <p>中运交投</p>
        <p class="p2">请输入支付密码</p>

        <!-- HTML的标签用到的属性尽量不要动，如有需要调整样式，可自行增加class即可 -->
        <!-- 整个div会默认撑满父容器宽高，继承父容器颜色字体大小，点击元素会弹出密码键盘 -->
        <div>
          <input type="number" min="0" v-model="moneyNum" class="money" placeholder="请输入提现金额">
        </div>
        <div class="passWord-box">
          <div id="ipt_pwd2" class="ipt_pwd">
            <span v-if="isSHowPasswordControl" id="LOGPASS2_SHOW">请输入密码</span>
            <input id="LOGPASS2" class="default input_search" type="password" disabled="disabled" />
            <div id="keyboardBtn2" class="ipt_pwd_rjp default"></div>
          </div>
          <!-- <div id="ipt_pwd3" class="ipt_pwd">
              <span id="LOGPASS3_SHOW">请确认密码</span>
              <input id="LOGPASS3" class="default input_search" type="text" disabled="disabled" />
              <div id="keyboardBtn3" class="ipt_pwd_rjp default"></div>
            </div> -->
        </div>
        <div class="get-password-box">
          <el-button @click="getPassword('off')">取消支付</el-button>
          <el-button id="get-password" @click="getPassword('pay')" :disabled="zf">确认支付</el-button>
        </div>
      </el-card>
      <el-card class="change-card" v-show = "isChange">
        <p class="p2">修改支付密码</p>

        <div class="passWord-box">
          <div id="ipt_pwd3" class="ipt_pwd">
            <span  id="LOGPASS2_SHOW3">请输入原支付密码</span>
            <input placeholder="请输入原支付密码" id="LOGPASS3" class="default input_search" type="password" disabled="disabled" />
            <div id="keyboardBtn3" class="ipt_pwd_rjp default"></div>
          </div>
        </div>
        
        <div class="passWord-box">
          <div id="ipt_pwd4" class="ipt_pwd">
            <span  id="LOGPASS2_SHOW4">请输入新支付密码</span>
            <input placeholder="请输入新支付密码" id="LOGPASS4" class="default input_search" type="password" disabled="disabled" />
            <div id="keyboardBtn4" class="ipt_pwd_rjp default"></div>
          </div>
        </div>
        <div class="passWord-box">
          <div id="ipt_pwd5" class="ipt_pwd">
              <span id="LOGPASS2_SHOW5">请确认新支付密码</span>
              <input placeholder="请确认新支付密码" id="LOGPASS5" class="default input_search" type="password" disabled="disabled" />
              <div id="keyboardBtn5" class="ipt_pwd_rjp default"></div>
          </div>
        </div>
        <div class="get-password-box">
          <el-button @click="changePassword('off')">取消</el-button>
          <el-button id="change-password" @click="changePassword('confirm')">确认</el-button>
        </div>
      </el-card>
      <el-card class="box-yzm" v-if="isyzm">
             <p>中运交投</p>
             <p class="p2">请输入验证码({{info.mobile}})</p>
             <div>
                <div class="input-box">
                <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">{{codeValue[0]}}</div>
                <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">{{codeValue[1]}}</div>
                <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">{{codeValue[2]}}</div>
                <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">{{codeValue[3]}}</div>
                <div class="code-item" :class="codeValue.length == 4 && inputFocus ? 'code-item-active' : ''">{{codeValue[4]}}</div>
                <div class="code-item" :class="codeValue.length >= 5 && inputFocus ? 'code-item-active' : ''">{{codeValue[5]}}</div> 
                <input 
                  class="input-code"
                  v-model="codeValue"
                  :maxlength="6"
                  type="tel"
                  @blur="codeInputBlur"
                  @focus="codeInputFocus"
                  @input="codeInputChange" />
              </div>
             </div>
            <div class="footer-btn">
              <el-button @click="() => {
                isyzm = false,
                codeValue = ''
              }">取消</el-button>
              <el-button @click="yzm()">确认</el-button>
            </div>
        </el-card>
    <cardc ref="card" v-if="iscard" @FSiscard="iscard = false" @getaccount="account()" @FSisAccount="isAccountFS()" :info="info" ></cardc>
    <add-or-update v-if="addOrUpdateVisible" @getPerfectInfo="getPerfectInfo()" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
// import * as echarts from 'echarts';
import "@/components/quill-editor/VueQuillEditor.js";

import cardc from '@/components/home-card'

import { titleConfig } from "@/components/quill-editor/titleConfig.js"; // 富文本文本提示语
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './home-add-or-update.vue'
export default {
  mixins: [mixinViewModule],
  components:{
    cardc,
    AddOrUpdate,
  },
  data() {
    return {
     
        selectedYear: '',
        selectedMonth: '',
        selectedDay: '',
     
      
      yearsList: this.generateYears(), 
      monthsList: [{value:' ',label:'不限'}],
      daysList: [{value:' ',label:'不限'}],
      
      rankList: [
        {ranking:1,funding:'中运集团'},
        {ranking:2,funding:'中运集团'},
        {ranking:3,funding:'中运集团'},
        {ranking:4,funding:'中运集团'},
        {ranking:5,funding:'中运集团'},
        {ranking:6,funding:'中运集团'},
        {ranking:7,funding:'中运集团'},
        {ranking:8,funding:'中运集团'},
        {ranking:9,funding:'中运集团'},
        {ranking:10,funding:'中运集团'},

      ],
      dateOptions:[
        { value: '近7日', label: '近7日' },
        { value: '近15日', label: '近15日' },
        { value: '近30日', label: '近30日' },
        { value: '当月', label: '当月' },
      ],
      rateData:[
        {value:820,name:'2019.01.01'},
        {value:932,name:'2019.01.02'},
        {value:901,name:'2019.01.03'},
        {value:934,name:'2019.01.04'},
        {value:1209,name:'2019.01.05'},
        {value:1330,name:'2019.01.06'},
        {value:820,name:'2019.01.01'},
        {value:932,name:'2019.01.02'},
        {value:901,name:'2019.01.03'},
        {value:934,name:'2019.01.04'},
        {value:1209,name:'2019.01.05'},
        {value:1330,name:'2019.01.06'},
        {value:820,name:'2019.01.01'},
        {value:932,name:'2019.01.02'},
        {value:901,name:'2019.01.03'},
        {value:934,name:'2019.01.04'},
        {value:1000,name:'2019.01.05'},
        {value:870,name:'2019.01.06'}
      ],
      dateValue:'',
      daysInMonth: [],
      infoList:[],
      balance:{},
      isOverDate:false,
      isOverDate1:false,
      zf:false,
      isChange:false,
      isWithdraw:false,
      isModify:false,
      loading:false,
      isSHowPasswordControl:false,
      isyzm:false,
      fileSize: 10,
      iscard:false,
      isAccount:true,
      info:{},
      infoData:{},
      moneyNum:'',
      codeValue:'',
      inputFocus:false,
      passwordInstance: "",
      passwordInstance1: "",
      passwordInstance2: "",
      passwordInstance3: "",
      perfectInfoObj: {},
      yzmData:{},
      options: {
        // "map_arr": "Wyc0MycsICc1NycsICc3MScsICcxMjEnLCAnMTI2JywgJzEyNCcsICc5MCcsICcxMTInLCAnODknLCAnOTMnLCAnMTA1JywgJzgxJywgJzExMycsICcxMjUnLCAnNjgnLCAnMzgnLCAnODUnLCAnNjUnLCAnMTE4JywgJzgwJywgJzg3JywgJzkxJywgJzQ0JywgJzMzJywgJzc4JywgJzg4JywgJzk2JywgJzEwOScsICc2MScsICc2NicsICc0MCcsICc4MicsICc3MicsICcxMjAnLCAnOTUnLCAnMTEwJywgJzQ2JywgJzg2JywgJzEwNycsICc1MCcsICc3MCcsICc5OCcsICcxMTcnLCAnMzYnLCAnMTAxJywgJzgzJywgJzQ4JywgJzExNCcsICc2NycsICc3NycsICcxMDgnLCAnMTAwJywgJzM1JywgJzczJywgJzY5JywgJzk5JywgJzEwMicsICc3NicsICc3NScsICcxMDQnLCAnNDknLCAnOTInLCAnNjInLCAnNTgnLCAnNTMnLCAnNzknLCAnOTcnLCAnNDUnLCAnNDEnLCAnMTE5JywgJzEyMycsICc1MScsICc2MycsICc0NycsICcxMDYnLCAnMzknLCAnMTExJywgJzExNScsICczNCcsICc5NCcsICcxMjInLCAnNjQnLCAnNTknLCAnMTE2JywgJzM3JywgJzc0JywgJzU1JywgJzYwJywgJzU0JywgJzUyJywgJzQyJywgJzg0JywgJzEwMycsICc1Nidd",
        // "license":"UjNpRHFyYWhSYzk5R1AzcTBCb1ZucURyLzhpekNiN1dGYkRWM1A3NjlnSzZnK0VZMDVzeno3akYrYS84VlR4UHhxRkFJRjJmeWdWKzJsU1hTV2hNMzg5WTBpbFk0bGhzU01GcXQvOTcyQmZ4akNtUXlrNEpMVnk0OXR0eXhRZ3RpYmFIMXkxcHg5UDZIbnBweG8rbGZqcS9Yekh1VGJ1K3kyZnBFS3didC9nPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjEwLCJub3RiZWZvcmUiOiIyMDIyMDUzMCIsIm5vdGFmdGVyIjoiMjAyMjExMzAifQ==",
        // "oid_partner":"2020042904425468",
        // "random_key":"241a606e-a4ff-49f4-b102-882b61b36bdf",
        // "random_value":"63000403063155227830323742731688",
        // "ret_code":"0000",
        // "ret_msg":"交易成功",
        // "rsa_public_content":"308189028181009017e40c4b053ef663903066618131e705a91641441d8bc5de082a12147559dcbc790e7b85a0e42a388effa2b7d0c5f734733ef14869fb735b5245bda1d79e32c35004288190e080f8abe8ae7c8f2ff81738c1c32d6e944be7ad1197cb1d8c76455d6da8d623a0513647f5a59d1e9aa6ca077f136040b550ad411728455bf6230203010001",
        // "sm2_key_hex":"1093A047C5CBF48283EC7A210703F3FF9EA4448DC15D56B4CD82FCB27DAD2D45F2BB0BF953BCEBB635D9D34E473ECEFC9F25880EB1669F94DE050A29AC86F308",
        // "user_id":"2021060401291390051"
      },
      uploadHeaders: {
        // 图片上传接口请求头
        Authorization: "token",
        Platform: "web",
      },
      uploadImgUrl: "/upload", // 上传的图片服务器地址
      content: "",
      // 富为本编辑器
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: {
            container: [
              // ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
              // ["blockquote", "code-block"], //引用，代码块
              // [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
              // [{ list: "ordered" }, { list: "bullet" }], //列表
              // [{ script: "sub" }, { script: "super" }], // 上下标
              // [{ indent: "-1" }, { indent: "+1" }], // 缩进
              // [{ direction: "rtl" }], // 文本方向
              // [{ size: ["small", false, "large", "huge"] }], // 字体大小
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
              // [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              // [{ font: [] }], //字体
              // [{ align: [] }], //对齐方式
              // ["clean"], //清除字体样式
              // ["image"], //上传图片
              // ['image','video','link']    //上传图片、上传视频、上传文件
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
              [{ align: [] }], // 对齐方式-----[{ align: [] }]
              // [{ size: fontSizeStyle.whitelist }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
              // [{ font: fonts }], // 字体种类-----[{ font: [] }]
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              // [{ direction: "ltl" }], // 文本方向-----[{'direction': 'rtl'}]
              // [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
              // [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
              // [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
              // [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
              // ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
              // ["clean"], // 清除文本格式-----['clean']
              // ["link", "image", "video"], // 链接、图片、视频-----['link', 'image', 'video']
            ],
            handlers: {
              image: function(value) {
                if (value) {
                  // 调用iview图片上传
                  document.querySelector(".upload-demo .ivu-btn").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  
  
  created(){
    this.generateDaysInMonth();
    this.getInfo()
    this.$store.commit('getInfo')
    this.getPerfectInfo()
    this.updateDays();
    this.rateData.forEach((item, index, array) => {
  if (index === 0) {
    // 第一项的 preValue 为空
    item.preValue = '';
  } else {
    // 其他项的 preValue 等于前一项的 value
    item.preValue = array[index - 1].value;
  }
});

  },
  //在dom创建完成后再调用
  mounted() {
  this.getFactor()
  setTimeout(() => {
    // this.initChart();
    // this.initChart1()
  }, 0);
  
  //富文本提示信息
    // this.$nextTick(() => {
    //   const oToolBar = document.getElementsByClassName("ql-editor")[0];
    //   const aButton = oToolBar.querySelectorAll("button");
    //   const aSelect = oToolBar.querySelectorAll("select");
    //   aButton.forEach(function(item) {
    //     if (item.className === "ql-script") {
    //       item.value === "sub" ? (item.title = "下标") : (item.title = "上标");
    //     } else if (item.className === "ql-indent") {
    //       item.value === "+1"
    //         ? (item.title = "向右缩进")
    //         : (item.title = "向左缩进");
    //     } else {
    //       item.title = titleConfig[item.classList[0]];
    //     }
    //   });
    //   aSelect.forEach(function(item) {
    //     item.parentNode.title = titleConfig[item.classList[0]];
    //   });
    // });
  },
  watch: {
        selectedYear(newYear) {
          this.updateMonths();
        },
        selectedMonth(newMonth) {
          this.updateDays();
        }
      },
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      const years = [
        { value: ' ', label: '不限' }, // 不限选项
        ...Array.from({ length: 31 }, (_, i) => {
          const year = currentYear - i;
          return {
            value: year.toString(),
            label: `${year}年`
          };
        })
      ];
      return years;
    },
    updateMonths() {
        if(this.selectedYear.trim() != ''){
          this.monthsList = [
            {value:' ',label:'不限'},
            ...Array.from({ length: 12 }, (_, i) => {
              const month = i + 1;
              return {
                value: month.toString(),
                label: `${month}月`
              };
            })
          ]
        }else{
          this.monthsList = [{value:' ',label:'不限'}]
        }
    },
    updateDays() {
      console.log(333,this.selectedMonth);
      
      if(this.selectedMonth.trim() != ''){
        const daysInMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
        this.daysList = [
        {value:' ',label:'不限'},
          ...Array.from({ length: daysInMonth }, (_, i) => {
              const day = i + 1;
              return {
                value: day.toString(),
                label: `${day}日`
              };
            })
        ]
        if (this.selectedDay > daysInMonth) {
          this.selectedDay = daysInMonth;
        }
      }else{
        this.daysList = [{value:' ',label:'不限'}]
      }
      
    },
    changeDate(){
      console.log(111,this.dateValue);
      if(this.dateValue == '近7日'){
        this.getLastSevenDays(6);
      }else if(this.dateValue == '近15日'){
        this.getLastSevenDays(14);
      }else if(this.dateValue == '近30日'){
        this.getLastSevenDays(29);
      }else{
        this.generateDaysInMonth()
      }  
      this.initChart1()
    },
    query(){
      
      console.log(11111,this.selectedYear,this.selectedMonth,this.selectedDay);
      
      
    },
    getLastSevenDays(dayNumber) {
      const days = [];
      const today = new Date();
      for (let i =dayNumber; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
        const day = String(date.getDate()).padStart(2, '0');
        days.push(`${year}.${month}.${day}`);
      }
      this.daysInMonth = days
      console.log(3434,days);
      
    },
    generateDaysInMonth(date) {
      const now = date ?  new Date(date) : new Date();
      const year = now.getFullYear();
      const month = now.getMonth(); // 0-based index for months
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      this.daysInMonth = Array.from({ length: daysInMonth }, (_, i) => {
        const day = i + 1;
        return `${year}.${String(month + 1).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
      });
      
    },
    // initChart1(){
    //   let chartDom = document.getElementById('tendency');
    //   let myChart = echarts.init(chartDom);
    //   let option = {
    //     xAxis: {
    //       type: 'category',
    //       data: this.daysInMonth,
    //       // splitLine: { show: false },
    //       // axisLine: { show: false },
    //     },
    //     yAxis: {
    //       type: 'value',
    //       splitLine: { show: false },
    //       axisLine: { show: true },
    //     },
    //     color: '#6246fc',
    //     series: [
    //       {
    //         // data: [820, 932, 901, 934, 1209, 1330,333,555,1000,901, 934, 1290, 1330,1333,1555,2000,1987],
    //         data:this.rateData,
    //         type: 'line',
    //         smooth: true,
    //         symbol:'circle',
    //         symbolSize:8,
    //         connectNulls:true,
    //         lineStyle: {
    //           width: 4 
    //         },
    //         emphasis: {
    //           label: {
    //             show: true,
    //             fontWeight: 'bold',
    //             fontSize:'16',
    //             color:'#7d59fe',
    //             backgroundColor:'#faeef7',
    //             padding: [10, 15, 20, 15],
    //             borderRadius: [0, 0, 30,30],
    //             formatter: function (params) {
    //               console.log(222333,params);
    //               const value = params.value;
    //               const preValue = params.data.preValue;
    //               const growthRate = preValue != '' ? ((value - preValue) / preValue * 100).toFixed(2) : '0%';
                  
    //               return `￥${value.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}\n${growthRate}%`; // 自定义标签显示的内容
    //             }
    //           }
    //         },
    //       }
    //     ]
    //   }
    //   myChart.setOption(option);
    // },
    // initChart() {
    //   let chartDom = document.getElementById('funnel');
    //   let myChart = echarts.init(chartDom);
    //   let option = {
       
    //     color: ['#936ef8','#ae92fa','#784af6'],
    //     series: [
    //       {
    //         name: 'Funnel',
    //         type: 'funnel',
    //         left: '10%',
    //         top: 0,
    //         width: '80%',
    //         height: '80%',
    //         min: 0,
    //         max: 100,
    //         minSize: '0%',
    //         maxSize: '100%',
    //         sort: 'descending',
    //         gap: 0,
    //         label: {
    //           show: true,
    //           position: 'inside'
    //         },
    //         emphasis: {
    //           label: {
    //             show: true,
    //             fontWeight: 'bold'
    //           }
    //         },
    //         labelLine: {
    //           length: 10,
    //           lineStyle: {
    //             width: 1,
    //             type: 'solid'
    //           }
    //         },
    //         itemStyle: {
    //           borderColor: '#fff',
    //           borderWidth: 1
    //         },
    //         emphasis: {
    //           label: {
    //             fontSize: 20
    //           }
    //         },
    //         data: [
    //           { value: 50, name: '50%' },
    //           { value: 10, name: '20%' },
    //           { value: 100, name: '100%' }
    //         ]
    //       }
    //     ]
    //   };

    //   myChart.setOption(option);
    // },
    // 日期格式化
    formatDate(dateString) {
      let dateObj 
      if(dateString){
        dateObj = new Date(dateString.replace(/-/g, '/'));
      }else{
        dateObj = new Date();
      }
      const year = dateObj.getFullYear();
      const month = this.addLeadingZero(dateObj.getMonth() + 1);
      const day = this.addLeadingZero(dateObj.getDate());
      const hours = this.addLeadingZero(dateObj.getHours());
      const minutes = this.addLeadingZero(dateObj.getMinutes());
      const seconds = this.addLeadingZero(dateObj.getSeconds());
      return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    },
    formatDate1(datetimeString){
      var dateObject = new Date(datetimeString);
      var year = dateObject.getFullYear();
      var month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1并补零
      var day = ('0' + dateObject.getDate()).slice(-2); // 获取日期并补零
      return `${year}-${month}-${day}`;
    },
    addLeadingZero(num) {
      return num < 10 ? `0${num}` : num;
    },
    goDetail(month){
      this.$router.push({ path: '/loan-expenditure',query:{month:month} })
    },
    getPerfectInfo(){
     
      this.loading = true
    this.$http.post('/loan/transfer/signMessageReturn').then(({data : res}) => {
      console.log(res)
      if(res.code != 0){
        this.$message.error( res.msg ) 
        return 
      } 
     this.perfectInfoObj = res.data ? res.data : {}
     this.loading = false
    })},
    // 验证码输入框input
    codeInputChange() {
      if (this.codeValue && this.codeValue.length >= 4) {
        // do soming...
      }
    },
    getFactor () {
    this.$http.get('/api/trans/getRandom').then(r => {
        if(r.data.code == '0'){
          console.log(r.data.data)
          this.options = r.data.data
          this.passwordInstance = this.initPassword(this.options)
          this.passwordInstance1 = this.initPassword1(this.options)
          this.passwordInstance2 = this.initPassword2(this.options)
          this.passwordInstance3 = this.initPassword3(this.options)
        }else{
          this.$message({
            type:"error",
            message:"获取随机因子失败"
          })
        }
        })
  },
    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },
    changePassword(r){
      if(r == 'off'){
        this.isChange = false
        this.passwordInstance1.clearPWD()
        this.passwordInstance2.clearPWD()
        this.passwordInstance3.clearPWD()
        return
      }
      this.passwordInstance1.setRandKey(this.options.random_value)
      this.passwordInstance2.setRandKey(this.options.random_value)
      this.passwordInstance3.setRandKey(this.options.random_value)
      const password1 = this.passwordInstance1.getOutputSM() // 国密加密密码
      const password2 = this.passwordInstance2.getOutputSM()
      const password3 = this.passwordInstance3.getOutputSM()
       
      if(password2 != password3){
        this.$message({
          type:'error',
          message:'两次输入的密码不一致'
        })
        return
      }
      console.log(22,password1);
      this.$http.post('/api/trans/userChangeLianLianPayPassword',{
        userId:this.info.id,
        password:password1,
        freshPassword:password2,
        randomKey: this.options.random_key
      }).then(res =>{
        console.log(555,res);
        if(res.data.code == 500){
          this.$message({
            type:'error',
            message:res.data.msg
          })
        return
        }
        this.$message({
            type:'success',
            message:res.data.data
        })
        this.isChange = false
        this.passwordInstance1.clearPWD()
        this.passwordInstance2.clearPWD()
        this.passwordInstance3.clearPWD()
        
        this.getFactor()
      })
      
    },
    getPassword(r) {
     
      if(r == 'off'){
        this.moneyNum = ''
        this.isSHowPasswordControl = false
        this.passwordInstance.clearPWD()
        return
      }
      if(this.moneyNum - 0 <= 0 || this.moneyNum - 0 > this.info.amtBalaval - 0){
        console.log(this.moneyNum)
        this.$message({
          type:'warning',
          message:'提现金额不能小于0 等于0 不能大于余额 '
        })
        
        return
      }
      this.zf = true
      this.passwordInstance.setRandKey(this.options.random_value) // 先设置随机key
      const password = this.passwordInstance.getOutputSM() // 国密加密密码
     
      const rsaPassword = this.passwordInstance.getOutput() // RSA加密密码
      // hash用于比对密码是否一致，同一个密码加密密文可能不同，hash一定相同
      const hash = this.passwordInstance.getHash() // RSA加密密码
      console.log(password)
      this.$http.post('/api/trans/withdrawal',{
        applyId:this.info.id,
        password:password, 
        postscript:"暂无说明",
        totalAmount:this.moneyNum,
        randomKey: this.options.random_key
      }).then(r => {
        this.zf = false
        let data = r.data.data
     
        if(data.ret_code == '0000'){
         this.passwordInstance.clearPWD()
         this.moneyNum = ''
          this.isSHowPasswordControl = false
        
          this.$message({
            type:'success',
            message:data.ret_msg
          })
          this.getInfo()
        }
        else if(data.ret_code == '8888'){
          this.yzmData = data
          this.$message({
            type:'warning',
            message:'请输入验证码'
          })
          this.passwordInstance.clearPWD()
          this.moneyNum = ''
          this.isSHowPasswordControl = false
          this.isyzm = true
        }
        else{
          this.$message({
            type:'error',
            message:data.ret_msg
          })
          this.passwordInstance.clearPWD()
          this.isSHowPasswordControl = false
        }
      }).catch(() => {
        this.zf = false
      })
      this.getFactor()
      // const hash2 = this.passwordInstance2.getHash() // RSA加密密码
      // console.log("确认密码HASH是", hash2)
    },
    yzm(){
      this.$http.post('/api/trans/validationSms',{
            applyId:this.info.id,
            token:this.yzmData.token,
            totalAmount:this.yzmData.total_amount,
            verifyCode:this.codeValue,
            txnSeqno:this.yzmData.txn_seqno,
            postscript:'交易明细'
      }).then(r => {
        console.log(r.data.data)
        if(r.data.data.ret_code == '0000'){
            this.$message({
              
              type:'success',
              message:r.data.data.ret_msg
            })
            this.codeValue = ''
            this.isyzm = false
            this.getInfo()
        }else{
          this.$message({
            type:'error',
            message:r.data.data.ret_msg
          })
        
         
        }
        this.getFactor()
        
      })
     
    },
    withdraw(){
      this.isSHowPasswordControl = true
    },
    changePwd(){
     this.isChange = true
    },
    isAccountFS(){
      // this.$http.get('sys/user/info',{params:{id:123213}}).then(r =>{
      // this.info = r.data.data
      // 判断是否已开户
      //  this.$refs.card.isBoxCard = false
      //   this.$refs.card.isshroff = true
      // if(this.info.bankOpenFlag == 1){
      //   this.$refs.card.isBoxCard = false
      //   this.$refs.card.isshroff = true
       
      // }else{
      //   this.$message({
      //     message: '您好，您还未完成开户',
      //     type: 'warning'
      //   });
      // }
    // })
      
    },
    // 拿到账户信息
    getInfo(){
      this.loading = true
      this.$http.get('sys/user/info').then(r =>{
        console.log(r.data.data)
        if(r.data.code == 0){
          this.loading = false
          this.info = r.data.data
          console.log(23,this.info);
          if(this.$hasPermission('system:data:userId')){
            this.$http.get(`/system/platformAccount/homeData/${r.data.data.id}`).then(res=>{
              if(res.data.code != 0){
                return this.$message.error(res.data.msg)
              }
              this.infoData = res.data.data || []

          })
          }
          
          this.$http.get(`/system/financial_details/getAvailableBalance/${r.data.data.id}`).then(res=>{
            console.log(123,res);
            if (res.data.code !== 0) {
              return this.$message.error(res.data.msg)
            }
              this.balance = res.data.data || {}
              var currentDateTime = new Date();
              if(this.balance.periodOfValidity){
                var givenDateTime = new Date(this.balance.periodOfValidity); 
                var timeDifference = (givenDateTime - currentDateTime) / (1000 * 60 * 60 * 24);
                console.log(222,timeDifference);
                if (timeDifference > 30) {
                  this.isOverDate = false
                } else {
                  this.isOverDate = true
                  this.isOverDate1 = false
                }
                if(timeDifference < 0 ){
                  this.isOverDate1 = true
                  this.isOverDate = false
                }else{
                  this.isOverDate1 = false
                }
              }
              

          })
          this.$http.get(`/system/config/list`).then(res=>{
            if(res.data.code != 0){
                return this.$message.error(res.data.msg)
            }
            this.infoList = res.data.data
          })
          
      
        }else{
          this.loading = false
          this.$message({
            type:'error',
          })
        }
     
        
    })
    // this.$http.get('sys/user/queryHomeUpdate').then(r =>{
    //     console.log(222,r)
    //     this.loading = false
    //     this.isModify = r.data.data
         
    // })
    // this.$http.get('sys/user/queryShowQueryHomeDeposited').then(r =>{
    //     console.log(222,r)
    //     this.loading = false
    //     this.isWithdraw = r.data.data
         
    // })
    },
    account(){
      this.$http.get('/api/account/openAccount').then((r) => {
        if(r.data.code != 0){
          this.$message.error(r.data.msg)
        }
            if(r.data.code == 0){
              window.open(r.data.data,"_blank",)
            }else{
              this.$message({
                type:'warning',
                message:r.data.msg,
                duration:4000
              })
            }
          })
      
    },
    onEditorBlur(e) {
      console.log(e, "失去焦点事件");
    },
    onEditorFocus(e) {
      console.log(e, "获得焦点事件");
    },
    onEditorChange(e) {
      console.log(e, "内容改变事件");
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 检验文件类型
      const isIMAGE =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp";
      if (!isIMAGE) {
        this.$message.error(`请上传图片类型文件！`);
        return false;
      }
      // 校检文件大小
      const isLt = file.size / 1024 / 1024 < this.fileSize;
      if (!isLt) {
        this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
        return false;
      }
      return true;
    },
    handleSuccess(res) {
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (res.code === 0) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, "image", res.data);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        this.$message.error("图片插入失败");
      }
    },

    handleContent() {},
    handleReset() {
      let quill = this.$refs.QuillEditor.quill;
      console.log(quill, "quillquill");
      // quill.container.innerHTML = "";
    },
    initPassword(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn2", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS2", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd2", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "",
        keyBordTop: "",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    initPassword1(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn3", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS3", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd3", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW3", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "-100px",
        keyBordTop: "50px",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    initPassword2(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn4", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS4", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd4", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW4", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "-100px",
        keyBordTop: "50px",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    initPassword3(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn5", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS5", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd5", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW5", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "-100px",
        keyBordTop: "50px",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
  },
};
</script>

<style lang="scss" scoped>
.warning_tip{
  background-color:  rgba(245, 154, 35, 0.09);
  display: flex;
  align-items: flex-start;
  padding: 8px 8px;
  color: #f08620;
  font-weight: bold;
  line-height: 18px;
  font-size: 12px;
  margin-bottom: 8px;
}
.aui-card--fill{
  background-color: rgb(241, 244, 245);
  border: none;
}
.mod-home {
  line-height: 1.5;
}

.home-box{
  display: flex;
  align-items: flex-start;
  width: 100%;
  .box-left{
    min-width: 320px;
    min-height: 1055px;//970px
    width: 18vw;
    height: 87vh;//85vh
    .en_info{
      line-height: 24px;
      color:  #aaaaaa;
      font-size: 13px;
      margin-left: 8px;
    }
    h3{
      line-height: 40px;
    }
    .flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }   
  }
  .box-right{
    width: 72vw;
    min-width: 800px;
    margin-left: 16px;
    .el-icon-warning{
      font-size: 15px;
      padding-right: 4px;
    }
    .warn_tip{
      width: 100%;
      min-width: 800px;
      background-color:  rgba(245, 154, 35, 0.18);
      color: #f20f0f;
      padding: 5px 20px;
      font-weight: bold;
      font-size: 12px;
    }
    .warn_tip1{
      width: 100%;
      min-width: 800px;
      background-color:  rgba(245, 154, 35, 0.09);
      color: #f08620;
      padding: 4px 20px;
      font-weight: bold;
      font-size: 12px;
    }
    .view_box{
      width: 35vw;
      min-width: 380px;
      background-color: #f7f9fa;
      padding:21px 26px;
      margin-top: 20px;
      .remaining{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .v_top,.v_bottom{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .v_top{
        margin-bottom: 20px;
      }
      .v-left{
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        flex-direction: column;
        margin-bottom: 0px;
      }
      .open_account{
        color:  #974ddb;
      }
      .account_status{
        color:  #d9001b;
        font-weight: bold;
      }
      .v_price{
        font-weight: bold;
        font-size: 22px;
        margin-right: 10px;
        max-width: 210px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .overview{
      min-height: 820px; //815 860 840
      height: 68vh;//69 70
    }
    .fee_box{
      display: flex;
      .f_left{
        min-width: 360px;
        width: 35vw;
      }
      .f_right{
        margin-left: 30px;
        min-width: 360px;
        width: 35vw;
      }
      .month_amount{
        font-size: 16px;
        color: #90a0ba;
        display: flex;
        align-items: center;
      }
      .f-price{
        font-size: 36px;
        font-weight: bold;
        color: #000;
        margin-left: 12px;
      }
      .f-price.color{
        color: #ff4c6d;
      }
      .month_fee{
        padding: 20px 26px;
        margin: 20px 0;
        font-size: 16px;
        color: #90a0ba;
        border-radius: 15px;
        box-shadow: 0px 3px 40px 0px rgba(174, 146, 250, 0.3);
        .mon_top{
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 20px;
          .t_left{
            margin-top: 12px;
            .t_price{
              font-weight: bold;
              font-size: 28px;
              color: #000;
              line-height:50px;
            }
          }
          .t_right{
            width: 46px;
            margin-right: 20px;
            img{
              width: 100%;
            }
          }
        }
        .mon_bottom{
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .b_left{
            .loan_price{
              color: #794cf6;
              font-weight: bold;
              font-size: 24px;
              margin-left: 26px;
            }
          }
          .b_right{
            padding:3px 16px;
            background-color:  #f5f8fb;
            border-radius: 3px;
          }
          .limit{
            display: flex;
            align-items: center;
            font-size: 14px;
            .limit_left{
              min-width: 110px;
            }
            .total_amount{
              font-weight: bold;
              font-size: 14px;
              color: #95aac9;
            }
          }
        }
      }
      .notarization_fee{
        min-height: 220px;
      }
      .sign_fee{
        padding:20px 26px;
        margin: 20px 0;
        font-size: 14px;
        color: #90a0ba;
        border-radius: 6px;
        border: 1px solid #e6edf7;
        .s_title{
          display: flex;
          align-items: center;
          img{
            margin-left: 4px;
            width: 15px;
          }
          

        }
        .s_top{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .s_price{
            color: #12263f;
            font-size: 20px;
            line-height: 40px;

          }
          .s_right{
            width: 25px;
            margin-right: 20px;
            img{
              width: 100%;
            }
          }
        }
        .s_bottom{
          margin-top: 20px;
          line-height: 24px;
          .s_number{
            color:  #794cf6;
            padding-right: 20px;
          }
        }
      }
    }
  }
}

.box-yzm{
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(92px,195px);
  width: 500px;
  height: 380px;
  p{
    text-align: center;
  }
  .p2{
    margin: 20px 0;
  }
  .footer-btn{
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 80px;
    position: relative;
    padding: 0px 15px;
    box-sizing: border-box;
    .input-code {
      width: 100%;
      height: 50px;
      position: absolute;
      left: 0px;
      top: 0px;
      box-sizing: border-box;
      color: transparent;
      background-color: transparent;
      opacity: 0;
    }
    .code-item {
      width: 40px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid#D8D8D8;
      margin-right: 10px;
      color: #444;
      font-size: 34px;
    }
    .code-item-active {
      border-bottom: 1px solid#F23026;
    }
}
.change-card{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-40%, -70%);
  width: 800px;
  height: 550px;
  text-align: center;
  z-index: 999999999999;
  .p2 {
    margin: 20px 0;
    font-size: 18px;
  }
  .get-password-box{
    margin: 60px 0;
    .el-button{
      margin: 0 30px;
    }
  }
}
.box-card1 {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translateX(100px);
  width: 920px;
  height: 480px;
  text-align: center;
  z-index: 999999999999;
  .p2 {
    margin: 20px 0;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}
.ipt_pwd {
  width: 245px;
  height: 37px;
  position: relative;
  // border: 1px solid #333;
  margin-right: 20px;
}
.passWord-box{
  border:2px solid #ccc ;
  border-radius: 15px;
  width: 300px;
  margin: 20px auto;
  margin-bottom: 30px;
}
.money{
  border-radius: 15px;
  height: 40px;
  width: 300px;
  margin: 10px auto;
  text-indent: 10px;
  border:2px solid #ccc;
}
.kg{
 text-indent: 30px;
}
::v-deep .editBtn{
  // border: 2px solid #04B4FF;
  // color: #04B4FF;
  padding: 6px 15px;
  font-size: 12px;
  color:  #2cb3a3;
  background: rgba(44, 179, 163, 0.12);
  border: 1px solid  #2cb3a3;
}
.admin_box{
  .analyse{
    color: #90a0ba;
    font-size: 16px;
  }
  .card_title{
    font-size: 18px;
    font-weight: bold;
  }

  .inquire_box{
    display: flex;
    justify-content: center;
    // .btn_search{
    //   margin-left: 20px;
    // }
    .inquire_form{
      display: flex;
      .el-form-item{
        margin-bottom: 0;
      }
      .el-select{
        width: 100px;
      }
    }
  }
  .data_show{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .show_item{
      width: 24%; 
      .item_content{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 10px 0;
      }
      .s_left{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #000;
        
        .num{
          font-size: 28px;
          font-weight: bold;
        }
        .tip{
          color: #666;
          font-size: 14px;
          margin-top: 8px;
        }
        font-weight: bold;
      }
    }
    .s_right{
      height: 60px;
      img{
        height: 100%;
      }
    }
  }
  .echarts{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .card_left{
      width: 59%;
      min-width: 500px;
      .tendency_title{
        position: relative;
        .date_select{
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
    .card_right{
      width: 40%;
      ::v-deep .el-table th{
        background-color: rgba(98, 70, 252, 0.25);
        padding: 6px;
      }
      ::v-deep .el-table td{
        padding: 6px;
      }
    }
  }
  .data_list{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .card_left{
      width: 40%;
      min-width: 400px;
      height: 400px;
      .analyse_data{
        margin: 30px 0;
        display: flex;
        justify-content: center;
      }
      .trapezoid_box{
        color: #fff;
        text-align: center;
        line-height: 60px;
        .trapezoid1 {
          width: 220px;
           height: 60px;
          background-color: #784af6;
          clip-path: polygon(0% 0%, 100% 0%, 83% 100%, 17% 100%);
        }
        .trapezoid2 {
          width:220px;
           height:60px;
          background-color: #936ef8;
          clip-path: polygon(17% 0%, 83% 0%, 66% 100%, 34% 100%);
        }
        .trapezoid3 {
          width:220px;
          height:60px;
          background-color: #ae92fa;
          clip-path: polygon(34% 0%, 66% 0%, 66% 100%, 34% 100%);
        }
      }
      .anal_num{
        font-size: 16px;
        min-width: 180px;
        width: 300px;
        // border: 1px solid;
        color: #90a0ba;
        line-height: 75px;
        // padding: 50px 0;
        span{
          color: #333;
        }
        .num1{
          position: relative;
          left: 10px;
        }
        .num2{
          position: relative;
          left: -20px;
        }
        .num3{
          position: relative;
          left: -50px;
        }
      }
    }
    .card_right{
      width: 59%;
      height: 400px;
    }
  }
}
::v-deep .el-table td{
  padding: 3px;
}
::v-deep .el-table th{
  padding: 0;
}


</style>
